import { QRCodeCanvas } from 'qrcode.react';
import React from 'react';
import styles from './EventDisplay.module.css';
import { Button } from 'react-bootstrap';

type Props = {
  attendanceToken: string;
  eventTitle: string;
  locationType: string;
};

export const EventQRCode = (props: Props) => {
  const hiddenQrRef = React.useRef<HTMLDivElement | null>(null);
  const qrcode = `${window.location.origin}/attend-qr/${props.attendanceToken}`;

  console.log('EventQRCode qrcode', qrcode);

  const handleDownload = () => {
    if (!hiddenQrRef.current) {
      console.error(`could not find hiddenQrRef`);
      return;
    }
    const canvas = hiddenQrRef.current.querySelector('canvas');
    if (!canvas) {
      console.error(`could not find canvas`);
      return;
    }
    // Create a new canvas to combine title and QR code
    const combinedCanvas = document.createElement('canvas');
    const ctx = combinedCanvas.getContext('2d');
    if (!ctx) {
      console.error(`could not find canvas 2d context`);
      return;
    }
    const qrCodeWidth = canvas.width;
    const qrCodeHeight = canvas.height;
    const titleFontSize = 24;
    const lineSpacing = 5;
    const padding = 50;

    // Helper function to wrap text
    const wrapText = (text: string, maxWidth: number, fontSize: number): string[] => {
      const words = text.split(' ');
      const lines: string[] = [];
      let currentLine = words[0];

      ctx.font = `bold ${fontSize}px Arial`;

      for (let i = 1; i < words.length; i++) {
        const word = words[i];
        const width = ctx.measureText(`${currentLine} ${word}`).width;
        if (width < maxWidth) {
          currentLine += ` ${word}`;
        } else {
          lines.push(currentLine);
          currentLine = word;
        }
      }
      lines.push(currentLine);
      return lines;
    };

    // Wrap the event title
    const wrappedText = wrapText(props.eventTitle, qrCodeWidth, titleFontSize);
    const textHeight = wrappedText.length * (titleFontSize + lineSpacing); // Add spacing between lines

    // Calculate new canvas dimensions
    const combinedWidth = qrCodeWidth + padding * 2;
    const combinedHeight = textHeight + padding * 2 + qrCodeHeight + padding;

    combinedCanvas.width = combinedWidth;
    combinedCanvas.height = combinedHeight;

    // Fill background with white
    ctx.fillStyle = '#FFFFFF'; // White background
    ctx.fillRect(0, 0, combinedCanvas.width, combinedCanvas.height);

    // Draw the title text
    ctx.fillStyle = '#000000'; // Black text color
    ctx.textAlign = 'center';
    ctx.font = `bold ${titleFontSize}px Arial`;
    wrappedText.forEach((line, index) => {
      const y = padding + titleFontSize + index * (titleFontSize + lineSpacing);
      ctx.fillText(line, combinedWidth / 2, y);
    });

    // Draw the QR code below the text
    const qrCodeY = padding + textHeight + padding;
    ctx.drawImage(canvas, padding, qrCodeY, qrCodeWidth, qrCodeHeight);

    // Generate image URL
    const imageUrl = combinedCanvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = 'QRCode.png'; // Suggest a filename for the download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className={styles.eventInfoCard}>
      <div className={styles.leftIcon}>
        <QRCodeCanvas value={qrcode} size={120} />
      </div>
      <div className={styles.rightBlock}>
        <div>
          <b>Attendance & Feedback QR Code</b>
        </div>
        <div className={styles.smallText}>
          {props.locationType === 'online'
            ? 'Attendees scan the QR code during the session to record attendance, submit feedback, and claim their certificate — all in one simple step.'
            : 'Print and place on-site. Users must scan to register attendance, complete feedback, and claim their attendance certificate.'}
        </div>
        <Button variant="secondary" size="sm" onClick={handleDownload}>
          Download QR code
        </Button>
      </div>

      {/* Hidden QR code for higher-resolution image generation */}
      <div ref={hiddenQrRef} className={styles.hiddenOffScreen}>
        <QRCodeCanvas value={qrcode} size={500} />
      </div>
    </div>
  );
};
